import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import type {
  Ch_preventionProgramEngagementInput,
  chSavePreventionProgramEngagementsMutation as ChSavePreventionProgramEngagementsMutationType,
} from "@/modules/patients/services/ch/__generated__/chSavePreventionProgramEngagementsMutation.graphql"
import { chSavePreventionProgramEngagementsMutation } from "@/modules/patients/services/ch/chSavePreventionProgramEngagementsMutation"
import type {
  De_preventionProgramEngagementInput,
  deSavePreventionProgramEngagementsMutation as DeSavePreventionProgramEngagementsMutationType,
} from "@/modules/patients/services/de/__generated__/deSavePreventionProgramEngagementsMutation.graphql"
import { deSavePreventionProgramEngagementsMutation } from "@/modules/patients/services/de/deSavePreventionProgramEngagementsMutation"
import { Country } from "@/types/__generated__/union-types"

type MutationType = ChSavePreventionProgramEngagementsMutationType | DeSavePreventionProgramEngagementsMutationType
export type PreventionProgramEngagementInput = Ch_preventionProgramEngagementInput | De_preventionProgramEngagementInput

export const useSavePreventionProgramEngagementsMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chSavePreventionProgramEngagementsMutation
      case "DE":
        return deSavePreventionProgramEngagementsMutation
    }
  })()

  const [commit, isFlight] = useMutationWithErrorToast<MutationType>(mutation, {
    errorMessage: "patient.agenda.booking.error.preventionProgramEngagementFailed",
  })

  const commitHandler = useCallback(
    (
      input: MutationType["variables"]["input"],
      addConnections: string[],
      onCompleted?: (response: MutationType["response"]) => void,
    ) => {
      commit({
        variables: { input, addConnections },
        onCompleted,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}
